const breakpoint = {
    mobileMax: 767,
    tabletMax: 1200,
};

export const themeLight = {
    color: {
        white: "#fff",
        lightBG: "#FBFBFE",
        lightGrey: "#E5E5E5",
        neutral: "#D1D5DA",
        slateGray: "#6E7E91",
        black: "#252525",
        blue: "#0366D6",
    },
    breakpoint
};

export const themeDark = {
    color: {
        white: "rgba(54, 54, 54, 0.72);",
        lightBG: "#252525",
        lightGrey: "#363636",
        neutral: "#D1D5DA",
        slateGray: "#fff",
        black: "#fff",
        blue: "#2188FF",
    },
    breakpoint
};